import { useSyncExternalStore } from 'react'

const getSnapshot = (breakpoint) => {
  const mobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
  if (mobileDevice) return true

  return window.innerWidth < breakpoint
}

const subscribe = (callback) => {
  window.addEventListener('resize', callback)
  return () => window.removeEventListener('resize', callback)
}

// This hook makes it possible to detect if the user is on a "mobile device" or not.
// Together with window width that was required for the theme settings preview
export const useIsMobile = (breakpoint = 576) => {
  const isMobile = useSyncExternalStore(
    subscribe,
    () => getSnapshot(breakpoint),
    false
  )

  // Return state
  return isMobile
}

export default useIsMobile
